import Skeleton from 'react-loading-skeleton';

import Button from '~/shared/components/ButtonsV2';
import Typography from '~/shared/components/Typography';
import BoltIcon from '~/shared/assets/icons/bolt.svg';
import FilterButton from '~/shared/components/filters/FilterButton';
import Guard from '~/shared/components/Guard';

import AutoscaleRulesLegend from './AutoscaleRulesLegend';

interface AutoscaleRulesHeaderProps {
  rulesCount: number | undefined;
  activeFilterCount: number;
  onOpenFilters: () => void;
  onClearFilters: () => void;
  onCreateRule: () => void;
  isOrganizationAccount?: boolean;
}

export default function AutoscaleRulesHeader({
  rulesCount,
  activeFilterCount,
  onOpenFilters,
  onClearFilters,
  onCreateRule,
  isOrganizationAccount = false,
}: AutoscaleRulesHeaderProps) {
  return (
    <div className="gap-2 ">
      <div className="flex justify-between items-center mt-3 2xl:mt-[18px] mb-3.5">
        <div className="flex  gap-7">
          {rulesCount !== undefined ? (
            <Typography variant="H5" fontWeight={500} color="text-primary-900 " className="">
              {rulesCount} Automatic Scaling Rules
            </Typography>
          ) : (
            <Skeleton
              containerClassName="block leading-[unset!important]"
              className="h-[24px] leading-[unset!important] rounded-[8px]"
              baseColor="var(--color-gray-200)"
              highlightColor="#FFFF"
              width={200}
            />
          )}
          <AutoscaleRulesLegend />
        </div>
        <div className="flex gap-4 items-center">
          <FilterButton
            activeFilterCount={activeFilterCount}
            onOpen={onOpenFilters}
            onClearAll={onClearFilters}
            label="Filters"
            className=""
            size="md-responsive"
            variant="third"
          />
          <Guard permission="datafy.write.autoscaling.rules">
            <Button
              className="flex gap-2 items-center "
              leftIcon={<BoltIcon className="size-5 aspect-square stroke-white" />}
              onClick={onCreateRule}
              size="md-responsive"
              disabled={isOrganizationAccount}
            >
              <Typography variant="p3" color="">
                Create new rule
              </Typography>
            </Button>
          </Guard>
        </div>
      </div>
    </div>
  );
}
